/**
 * Utils function to check validity of email compliant to the RFC 5322 Standard
 * @param {String} email, the input email we want to compare it's validity
 */
export const checkEmailValidity = email => {
  // If it is an email, make it complies with the RFC 5322 standard for email format
  // eslint-disable-next-line no-useless-escape
  const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.exec(email) !== null;
};
